import React from 'react';
import {Close, Content, Description, Overlay, Portal, Root, Title} from '@radix-ui/react-dialog';
import styles from './dialog.module.scss';
import Button from 'src/components/button';
import classNames from 'classnames';

interface DialogProps {
  open: boolean;
  title: string;
  description?: string;
  confirmationText: string;
  onConfirm: () => void;
  cancelationText: string;
  onCancel: () => void;
}

const Dialog = ({
  open,
  title,
  description,
  confirmationText,
  onConfirm,
  cancelationText,
  onCancel,
}: DialogProps) => {
  return (
    <Root open={open}>
      <Portal>
        <Overlay className={styles.overlay} />
        <Content className={styles.content}>
          <Title className={classNames(styles.text, styles.title)}>{title}</Title>
          {!!description && <Description className={classNames(styles.text, styles.description)}>{description}</Description>}
          <div className={styles.actions}>
            <Close asChild>
              <Button className='btn btn-danger' onClick={onConfirm}>
                {confirmationText}
              </Button>
            </Close>
            <Close asChild>
              <Button className='btn' onClick={onCancel}>
                {cancelationText}
              </Button>
            </Close>
          </div>
        </Content>
      </Portal>
    </Root>
  );
};
Dialog.displayName = 'Dialog';

export default Dialog;
